module.exports = __webpack_public_path__ + "static/Ginger_CEOO-f32a20e33a5bdcbb90c77b1dc6e79c0a.png";